module.exports = __webpack_public_path__ + "img/revexpo_1349.839e36ff.jpg";